<template>
    <div class="AddNode">
        <el-form :model="params" :rules="rules" ref="params" >
            <el-form-item label="节点名称：" prop="nodeName">
                <el-input placeholder="请输入节点名称" v-model="params.nodeName" clearable style="width: 280px;"></el-input>
            </el-form-item>
            <el-form-item label="节点类型：" prop="type">
                <el-input v-model="params.type" placeholder="请输入节点类型" clearable style="width: 280px;"></el-input>
                <!-- <el-select v-model="params.type">
                    <el-option v-for="item in NodeTypeList" :key="item" :label="item" :value="item"></el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item label="节点图片：" style="width:600px;" prop="imgUrl">
                <el-col :span="7">
                    <div class="cover">
                        <el-upload v-loading="uploadloading" :auto-upload="true" class="avatar-uploader" :headers="{Authorization:Authorization}" :action="actionUrl" :limit="1" name="images" :show-file-list="false" :before-upload="handlebeforeupload" :on-success="handleAvatarSuccess" accept="image/jpeg,image/gif,image/png" list-type="picture-card">
                        <img v-if="params.imgUrl" :src="params.imgUrl" class="el-upload--picture-card" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </div>
                </el-col>
                <el-col :span="11">
                    <p style="line-height: 26px;">说明：请发布与网站主题相关的图片，图片大小需控制在10M以内文件格式请用.jpg .png .jpeg图片尺寸建议：1比1.5</p>
                </el-col>
            </el-form-item>
            <el-form-item label="节点描述：" prop="nodeDescription">
                <el-input type="textarea" v-model="params.nodeDescription" placeholder="请输入节点描述" clearable style="width: 280px;"></el-input>
            </el-form-item>
            <el-form-item label="其他属性：">
                <div style="display: inline-block;">
                    <el-row :span="7" style="margin-bottom: 10px;" v-for="(item,index) in params.otherAttr">
                        <el-col :span="6"><el-input v-model="item.attrName" placeholder="请输入属性名"></el-input></el-col>
                        <el-col :span="8" style="margin-left: 20px;"><el-input v-model="item.attrValue" placeholder="请输入属性值"></el-input></el-col>
                        <el-col :span="2" style="margin-left: 20px;" v-if="index == params.otherAttr.length-1"><el-button type="primary" @click="ADDattribute">新增</el-button></el-col>
                        <el-col :span="2" style="margin-left: 20px;" v-else><el-button type="primary" @click="Delete(index)">删除</el-button></el-col>
                    </el-row>
                </div>
            </el-form-item>
        </el-form>
        <div style="text-align: center;">
            <el-button type="primary" @click="submitForm('params')">{{$route.query.type?'修改':'提交'}}</el-button>
            <el-button @click="$router.go(-1)">取消</el-button>
        </div>
    </div>
</template>
<script>
export default{
    name:'AddNode',
    data() {
        return {
            uploadloading:false,
            actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
            Authorization:sessionStorage.getItem('Authorization'),
            rules:{
                nodeName:[{ required: true, message: '请输入节点名称', trigger: 'blur'}],
                type:[{ required: true, message: '请输入节点类型', trigger: 'change'}],
                imgUrl:[{ required: true, message: '请上传节点图片', trigger: 'change'}],
                nodeDescription:[{ required: true, message: '请输入节点描述', trigger: 'blur'}],
            },
            NodeTypeList:[],
            iscopy:this.$route.query.iscopy,
            params:{
                model:'industry',
                nodeName:'',
                type:'',
                imgUrl:'',
                nodeDescription:'',
                otherAttr:[
                    {attrName:'',attrValue:''}
                ]
            }
        }
    },
    created() {
        // this.getNodeTypeList();
        if(this.$route.query.type){
            this.getNodeListByNodeId(this.$route.query);
        }
    },
    methods: {
        // 详情
        getNodeListByNodeId(e){
            this.$Http_Post('node/getNodeListByNodeId',{model:'industry',type:e.type,nodeId:e.id}).then(res=>{
                if(res.Code == 0){
                    this.params = res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        handleAvatarSuccess(file){
            this.params.imgUrl=file.Data;
            this.uploadloading=false;
        },
        handlebeforeupload(file){
            if (file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
                this.uploadloading=true;
            }else{
                this.$message({type: 'error', message:"请上传正确的图片格式"});
                return false;
            }
        },
        // 获取节点类型
        getNodeTypeList(){
            this.$Http_Post('node/getNodeTypeList',{model:'industry'}).then(res=>{
                if(res.Code==0){
                    this.NodeTypeList = res.Data;
                }
            })
        },
        // 添加属性
        ADDattribute(){
            if(this.params.otherAttr[this.params.otherAttr.length-1].attrName=='' || this.params.otherAttr[this.params.otherAttr.length-1].attrValue==''){
                this.$message({type: 'error', message:"请先填写完整属性内容"});
                return false
            }
            this.params.otherAttr.push({attrName:'',attrValue:''})
        },
        Delete(i){
            this.params.otherAttr.splice(i,1);
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.params['model'] = 'industry';
                let URL = this.iscopy == 0?'node/editNode':'node/createNode';
                this.$Http_Post(URL,this.params).then(res=>{
                    if(res.Code == 0){
                        this.$message({type: 'success', message:res.Message});
                        if(!this.$route.query.type){
                            this.params = this.$options.data().params;
                        }
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                });
            } else {
                this.$message({type: 'error', message:"请填写完整信息"});
                return false;
            }
            });
      },
    },
}
</script>
<style>
.AddNode{background: #fff;padding: 20px;}
.AddNode .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px; cursor: pointer;position: relative; overflow: hidden;}
.AddNode .avatar {width: 178px;height: 178px;display:inline-block;}
.AddNode .el-upload{border: none !important;}
</style>